import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/async';
import { components } from 'react-select';

import './styles/icon_select.scss';
import axios from 'axios';
import { debounce } from 'lodash';


const Option = ({ ...props }) => (
  <components.Option {...props}>
    <i className={`fa-solid fa-${props.data.value} fa-lg fa-fw icon`} />
    {props.label}
  </components.Option>
);

Option.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

const SingleValue = ({ ...props }) => (
  <components.SingleValue {...props}>
    <i className={`fa-solid fa-${props.data.value} fa-lg fa-fw icon`} />
    {props.data.label}
  </components.SingleValue>
);

SingleValue.propTypes = {
  data: PropTypes.object.isRequired
};

const loadOptions = (inputValue, callback) => {
  axios.post('https://api.fontawesome.com', {
    query: `query { search(version: "6.0.0", query: "${inputValue}", first: 5) { id } }`
  }).then((response) => {
    const icons = response.data?.data?.search || [];
    callback(icons.map(icon => ({ value: icon.id, label: icon.id, prefix: 'fas' })));
  }).catch(() => callback([]));
};
const debouncedLoadOptions = debounce(loadOptions, 400);

export default function IconSelect({ value, onChange }) {
  const handleChange = useCallback((option) => {
    onChange({
      iconName: option.value,
      prefix: option.prefix
    });
  }, [onChange]);

  return (
    <AsyncSelect
      cacheOptions
      className="icon-select"
      components={{ Option, SingleValue }}
      loadOptions={debouncedLoadOptions}
      value={value ? { value: value.iconName, label: value.iconName, prefix: 'fas' } : undefined}
      onChange={handleChange}
    />
  );
}

IconSelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
};
